var flyoutMagicTriangle;

flyoutMagicTriangle = require('./flyout_magic_triangle');

module.exports = {
  init: function() {
    var $firstLink, $goodsTab, $menuElem, $nestedLinks, flyoutInstance, flyoutOpts;
    $goodsTab = $('#subnav-goods-tab');
    if (!($menuElem = $goodsTab.find('.ls-gcx-flyout-menu')).length) {
      return;
    }
    flyoutOpts = {
      $menuElem: $menuElem,
      rowSelector: '.ls-gcx-flyout-nested-links',
      delay: 200,
      onActivateRow: function(elem) {
        return $(elem).addClass('ls-gcx-flyout-active');
      },
      onDeactivateRow: function(elem) {
        return $(elem).removeClass('ls-gcx-flyout-active');
      }
    };
    $('.ls-gcx-flyout-category-image').lazyload({
      container: '#goods-tab',
      event: 'mouseover',
      performantScroll: true,
      skip_initial_check: true,
      skip_invisible: false
    });
    flyoutInstance = flyoutMagicTriangle(flyoutOpts);
    if (!flyoutInstance) {
      return;
    }
    $nestedLinks = $menuElem.find('.ls-gcx-flyout-nested-links');
    $nestedLinks.on('tap', function(e) {
      e.stopPropagation();
      return flyoutInstance.activateRow($(e.currentTarget));
    });
    $firstLink = $nestedLinks.first();
    return $goodsTab.bind('tab:active', function() {
      return flyoutInstance.activateRow($firstLink);
    });
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvbW9kdWxlcy9naWdfYm9keS9oZWFkZXIvc3ViX25hdi9mcm9udGVuZC9pbml0X2ZseW91dC5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9tb2R1bGVzL2dpZ19ib2R5L2hlYWRlci9zdWJfbmF2L2Zyb250ZW5kL2luaXRfZmx5b3V0LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLG1CQUFBLEdBQXNCLE9BQUEsQ0FBUSx5QkFBUjs7QUFFdEIsTUFBTSxDQUFDLE9BQVAsR0FDRTtFQUFBLElBQUEsRUFBTSxTQUFBO0FBQ0osUUFBQTtJQUFBLFNBQUEsR0FBWSxDQUFBLENBQUUsbUJBQUY7SUFDWixJQUFBLENBQWMsQ0FBQyxTQUFBLEdBQVksU0FBUyxDQUFDLElBQVYsQ0FBZSxxQkFBZixDQUFiLENBQW1ELENBQUMsTUFBbEU7QUFBQSxhQUFBOztJQUVBLFVBQUEsR0FBYTtNQUNYLFdBQUEsU0FEVztNQUVYLFdBQUEsRUFBYSw2QkFGRjtNQUdYLEtBQUEsRUFBTyxHQUhJO01BSVgsYUFBQSxFQUFlLFNBQUMsSUFBRDtlQUNiLENBQUEsQ0FBRSxJQUFGLENBQU8sQ0FBQyxRQUFSLENBQWlCLHNCQUFqQjtNQURhLENBSko7TUFNWCxlQUFBLEVBQWlCLFNBQUMsSUFBRDtlQUNmLENBQUEsQ0FBRSxJQUFGLENBQU8sQ0FBQyxXQUFSLENBQW9CLHNCQUFwQjtNQURlLENBTk47O0lBV2IsQ0FBQSxDQUFFLCtCQUFGLENBQWtDLENBQUMsUUFBbkMsQ0FDRTtNQUFBLFNBQUEsRUFBVyxZQUFYO01BQ0EsS0FBQSxFQUFPLFdBRFA7TUFFQSxnQkFBQSxFQUFrQixJQUZsQjtNQUdBLGtCQUFBLEVBQW9CLElBSHBCO01BSUEsY0FBQSxFQUFnQixLQUpoQjtLQURGO0lBT0EsY0FBQSxHQUFpQixtQkFBQSxDQUFvQixVQUFwQjtJQUVqQixJQUFBLENBQWMsY0FBZDtBQUFBLGFBQUE7O0lBRUEsWUFBQSxHQUFlLFNBQVMsQ0FBQyxJQUFWLENBQWUsNkJBQWY7SUFDZixZQUFZLENBQUMsRUFBYixDQUFnQixLQUFoQixFQUF1QixTQUFDLENBQUQ7TUFDckIsQ0FBQyxDQUFDLGVBQUYsQ0FBQTthQUNBLGNBQWMsQ0FBQyxXQUFmLENBQTJCLENBQUEsQ0FBRSxDQUFDLENBQUMsYUFBSixDQUEzQjtJQUZxQixDQUF2QjtJQUlBLFVBQUEsR0FBYSxZQUFZLENBQUMsS0FBYixDQUFBO1dBRWIsU0FBUyxDQUFDLElBQVYsQ0FBZSxZQUFmLEVBQTZCLFNBQUE7YUFDM0IsY0FBYyxDQUFDLFdBQWYsQ0FBMkIsVUFBM0I7SUFEMkIsQ0FBN0I7RUFqQ0ksQ0FBTiJ9
